import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { TaskInternalPartnerFileInterface } from "./definitions/task-internal-partner-file-interface";
import { Observable } from "rxjs";
import { ErrorsInterface } from "../errors/errors-interface";
import removeInternalPartnerTaskFileMutation from "./mutations/remove";
import { FetchResult } from '@apollo/client/core';

interface RemoveInternalFileTaskResponse {
  taskInternalPartnerFile: {
    remove: {
      output: TaskInternalPartnerFileInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class RemoveInternalPartnerTaskFileService {
  constructor(private apollo: Apollo) {}

  removeInternalPartnerTaskFile(
    taskFileId: string
  ): Observable<FetchResult<RemoveInternalFileTaskResponse>> {
    return this.apollo.mutate<RemoveInternalFileTaskResponse>({
      mutation: removeInternalPartnerTaskFileMutation,
      variables: {
        taskFileId: taskFileId,
      },
    });
  }
}
